/**
 * @voltxampere/ui — CH340G USB-UART bridge variant (Sprint 49-6)
 *
 * WCH (Nanjing) USB-to-UART converter. Low-cost SOIC-16 part used
 * in clone Arduino Nano boards, ESP modules, Asian dev boards.
 * Driver historically Windows-only; Linux/Mac support landed
 * upstream around 2017.
 *
 * Reference: WinChipHead CH340 datasheet rev 2C (2018).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const icCh340g = {
    id: "ch340g",
    nameTr: "CH340G (USB-UART Köprü, ekonomik)",
    nameEn: "CH340G (USB-UART Bridge, low-cost)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "CH340G",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        busType: "usb-uart",
        vendor: "WCH",
        package: "SOIC-16",
        maxBaudRate: 2_000_000,
        hasModemControl: true,
        voltageRangeV: { min: 4.5, max: 5.5 },
        crystalRequired: true, // 12 MHz external
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=ic-ch340g.js.map